import React from 'react';
import exact from 'prop-types-exact';
import PageLayout from '../../../layouts/PageLayout';
import WellTableEnhanced from './components/WellTableEnhanced';

import { routerProps } from '../../../propTypes';

const propTypes = exact({
  ...routerProps,
});

const WellList = (props) => {
  return (
    <PageLayout
      title="Well List"
      render={() => { return <WellTableEnhanced />; }}
    />
  );
};

WellList.propTypes = propTypes;

export default WellList;
